<template>
  <div class="relative" v-click-outside="hideDropdown">
    <slot
      name="toggle"
      v-bind="{
        toggleDropDown,
        hideDropdown,
        id,
        toggleText,
        mode,
        toggleClass,
      }"
    >
      <button
        :class="[`${toggleClass}`, { selected: isFiltered }]"
        :id="id"
        @click="toggleDropDown"
      >
        <slot
          name="handler"
          v-bind="{ toggleDropDown, hideDropdown, id, toggleText }"
        >
          {{ toggleText }}
        </slot>
      </button>
    </slot>
    <div
      :class="[
        `absolute right-0 border rounded-lg z-50 ${menuClass}`,
        isActive ? 'block' : 'hidden',
        mode === 'dark' ? 'bg-dark-70 border-dark-50' : 'bg-white-100',
      ]"
      :style="`min-width: ${menuMinWidth}px;`"
    >
      <slot v-bind="{ toggleDropDown, hideDropdown }" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    toggleText: {
      type: String,
      default: "Dropdown",
    },
    toggleClass: {
      type: String,
      default: "",
    },
    menuClass: {
      type: String,
      default: "",
    },
    menuMinWidth: {
      type: [String, Number],
      default: "200",
    },
    mode: {
      type: String,
      default: "light",
    },
    option: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    isFiltered() {
      return !this.isActive &&
        this.option &&
        (this.option.min || this.option.max)
        ? true
        : false;
    },
  },
  methods: {
    toggleDropDown() {
      this.$emit("toggle");
      this.isActive = !this.isActive;
    },
    hideDropdown() {
      this.$emit("hide");
      this.isActive = false;
    },
  },
};
</script>
